import React, { useContext, useState } from "react";
import { ChildrenProps } from "../customTypes/valueTypes";
import { AgencyHierachyDataResponse, AvailableProductsList, DashboardDataResponse } from "../Models/tableDetailsModel";

const AgencyInfoContext = React.createContext<AgencyInfoPayload | null>(null);

export interface AgencyInfoPayload {
    agencyHierachyResponse: AgencyHierachyDataResponse | null;
    setAgencyHierachyResponse: React.Dispatch<React.SetStateAction<AgencyHierachyDataResponse | null>>;
    allAgencyData: DashboardDataResponse | null;
    setAllAgencyData: React.Dispatch<React.SetStateAction<DashboardDataResponse | null>>;
    productFilterList: AvailableProductsList[] | null;
    setProductFilterList: React.Dispatch<React.SetStateAction<AvailableProductsList[] | null>>;
}

const AgencyInfoProvider = ({ children }: ChildrenProps) => {

    const [agencyHierachyResponse, setAgencyHierachyResponse] = useState<AgencyHierachyDataResponse | null>(null)
    const [allAgencyData, setAllAgencyData] = useState<DashboardDataResponse | null>(null)
    const [productFilterList, setProductFilterList] = useState<AvailableProductsList[] | null>(null);


    const payload: AgencyInfoPayload = {
        agencyHierachyResponse,
        setAgencyHierachyResponse,
        allAgencyData,
        setAllAgencyData,
        productFilterList,
        setProductFilterList
    };

    return (
        <AgencyInfoContext.Provider value={payload}>
            {children}
        </AgencyInfoContext.Provider>
    )
}

const useAgencyInfo = (): AgencyInfoPayload => {
    const context = useContext(AgencyInfoContext);
    if (!context) {
        throw new Error("useAgencyInfo must be used within a AgencyInfoContext");
    }
    return context;
};

export { AgencyInfoContext, AgencyInfoProvider, useAgencyInfo };